import { render } from "./ExamRequestItems.vue?vue&type=template&id=73def2ce&scoped=true"
import script from "./ExamRequestItems.vue?vue&type=script&lang=js"
export * from "./ExamRequestItems.vue?vue&type=script&lang=js"

import "./ExamRequestItems.vue?vue&type=style&index=0&id=73def2ce&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73def2ce"]])

export default __exports__